export default "__VITE_ASSET__CihYbXks__"